<template>
  <Modal
    :mask-closable="false"
    :closable="false"
    title="手动购买"
    v-model="modal">
    <Form ref="handleForm" :model="handleForm" :rules="handleValidate" :label-width="110">
      <Row>
        <Col :sm="24" :xs="24">
          <FormItem label="选择代理商:" prop="agentName">
            <Select
              v-model.trim="handleForm.agentName"
              filterable
              remote
              clearable
              :remote-method="getAgent"
              :loading="commodityLoading"
              @on-select="selectAgent"
              @on-query-change="changeAgent">
              <Option v-for="(option, index) in agentList" :value="option.id" :key="index" >{{option.agentName}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24" v-if="handleForm.agentName">
          <FormItem label="选择商品:" prop="agentCommodityId" >
            <Select
              v-model.trim="handleForm.agentCommodityId"
              filterable
              remote
              clearable
              :loading="commodityLoading">
              <Option v-for="(option, index) in commodityOptions" :value="option.id" :key="index">{{option.commodityName}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="购买数量:" prop="buyNumber">
            <InputNumber :max="200" :min="1" v-model="handleForm.buyNumber"></InputNumber>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" @click="hide" :disabled="loading">取消</Button>
      <Button type="primary" :loading="loading" @click="submit">购买</Button>
    </div>
  </Modal>
</template>

<script>
import api from '../../api'

export default {
  name: 'ManualRecharge',
  data () {
    return {
      modal: false,
      loading: false,
      commodityLoading: false,
      commodityOptions: [],
      handleForm: {
        agentName: '',
        agentCommodityId: '',
        buyNumber: 1,
        agentId: ''
      },
      handleValidate: {
        agentName: [
          { required: true, whitespace: true, message: '请选择代理商', trigger: 'change' }
        ],
        agentCommodityId: [
          { required: true, whitespace: true, message: '请选择购买的商品', trigger: 'change' }
        ]
      },
      // 代理商
      agentName: '',
      agentList: []
    }
  },
  methods: {
    show () {
      this.modal = true
    },
    hide () {
      this.$refs['handleForm'].resetFields()
      this.loading = false
      this.modal = false
    },
    submit () {
      this.$refs['handleForm'].validate((valid) => {
        if (valid) {
          this.submitForm()
        } else {
          this.$Message.error('请填写必填项目!')
        }
      })
    },
    submitForm () {
      let queryParams = {
        ...this.handleForm
      }
      this.loading = true
      delete queryParams.agentName
      delete queryParams.agentId
      api.order.carmiManualBuy(queryParams).then(() => {
        this.$emit('success')
        this.$Message.success('购买成功！')
        this.hide()
      }).catch(err => {
        this.$Message.error('购买失败：' + err.message)
      }).then(() => {
        this.loading = false
      })
    },
    getAgentList (val) {
      api.agent.agentList({
        pageNum: 1,
        pageSize: 999,
        agentName: val
      }).then(res => {
        this.agentList = res.data.records
      }).catch(err => {
        this.$Message.error('获取代理商列表失败：' + err.message)
      })
    },
    queryAgentCommodities (agentId) {
      api.agent.agentCommodityList({
        agentId: agentId,
        pageNum: 1,
        pageSize: 999
      }).then(res => {
        // TODO：临时解决方案，通过类别名称来过滤代理的商品
        const result = res.data.records || []
        this.commodityOptions = []
        result.forEach(item => {
          item.labelName === '卡密类' && this.commodityOptions.push(item)
        })
      }).catch(err => {
        this.$Message.error('获取代理商商品失败：' + err.message)
      })
    },
    // 选中代理商
    selectAgent (val) {
      this.selectAgentId = val.value
      this.queryAgentCommodities(val.value)
      this.handleForm.agentCommodityId = ''
      this.commodityOptions = []
    },
    // 改变代理商输入框
    changeAgent (val) {
      this.throttle(this.getAgentList, 500, val)
    },
    // 远程获取代理商
    getAgent () {
      this.throttle(this.getAgentList, 500)
    },
    throttle (fn, delay, val) {
      clearTimeout(fn.timeoutId)
      fn.timeoutId = setTimeout(function () {
        fn.call(val)
      }, delay)
    }
  },
  mounted () {
    this.getAgentList()
  }
}
</script>
